import Nav from '../components/Nav';
import Hero from '../components/sections/Hero';
import EmotionalOpening from '../components/sections/EmotionalOpening';
import ComingHome from '../components/sections/ComingHome';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Values from '../components/sections/Values';
import Journey from '../components/sections/Journey';
import Blog from '../components/sections/Blog';
import Testimonials from '../components/sections/Testimonials';
import Contact from '../components/sections/Contact';
import Footer from '../components/Footer';
import { Toaster } from 'sonner';

export default function Home() {
  return (
    <main data-testid="home-page" className="relative">
      <Toaster position="bottom-center" toastOptions={{ style: { background: '#FAFAF8', color: '#2C2C2A', border: '1px solid rgba(122,158,134,0.3)' } }} />
      <Nav />
      <Hero />
      <EmotionalOpening />
      <ComingHome />
      <About />
      <Services />
      <Values />
      <Journey />
      <Blog />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
